G.BoardDirt = function(board) {
  G.BoardLayer.call(this, board, {
    constructor: G.Dirt,
    maxHp: 3,
    hpToken: true,
    editorSymbol: "dirt",
    collectableType: "dirt",
  });
};

G.BoardDirt.prototype = Object.create(G.BoardLayer.prototype);